import { useState, useEffect } from "react"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"
import ResponsabilidadCivilConstruccionExtraForm from './ResponsabilidadCivilConstruccionExtraForm'

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  FormFeedback,
  Modal
} from "reactstrap"

// ** Third Party Components
import * as yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import Flatpickr from "react-flatpickr"
import { Check, X, Trash} from "react-feather"

const AsesoriaResponsabilidadCivilConstruccionForm = (props) => {
  const [sumaAseguradaSolicitaAlt, setsumaAseguradaSolicitaAlt]  = useState('')

  const catalogoTipoMaquinaria = [
    {
      label: 'Si es propia',
      value: 'Si es propia'
    },
    {
      label: 'Si es arrendada',
      value: 'Si es arrendada'
    },
    {
      label: 'Con operador',
      value: 'Con operador'
    },
    {
      label: 'Sin Operador',
      value: 'Sin Operador'
    }
  ]

  const catalogoSumaAsegurada = [
    {
      label: '$ 100,000 MXN',
      value: '$ 100,000 MXN'
    },
    {
      label: '$ 250,000 MXN',
      value: '$ 250,000 MXN'
    },
    {
      label: '$ 500,000 MXN',
      value: '$ 500,000 MXN'
    },
    {
      label: '$ 1,000,000 MXN',
      value: '$ 1,000,000 MXN'
    },
    {
      label: 'Otra cantidad',
      value: 'Otra cantidad'
    }
  ]

  function datosAsesoria() {
      return {
        datosGenerales: {
          solicitante: '',
          domicilioCodigoPostal: '',
          domicilioCobroCodigoPostal: '',
          actividadGiro: '',
          formaPago: '',
          vigenciaSolicitud: {
            desde: '',
            hasta: ''
          },
          sumaAseguradaSolicita: '',
          experienciaSiniestrosTresUltimosAnos: ''
        },
          seguroAnual: {
            reparacionesAfectenStructurales: false,
            apuntalamientos: false,
            demoliciones: false,
            obrasEmpleosExplosivos: false,
            pilotajes: false,
            cimentacion: false,
            excavacion: false,
            techados: false,
            otrosDescribalos: '',
            obrasDistintas: '',
            empleaSubcontratistas: '',
            subcontratistasEmpleados : [],
            asesoriaPrincipal: '',
            responsabilidadRiesgoSubcontratista: false,
            participaConsorcioConstruccion: '',
            volumenAnualObrasAnoAnterior: '',
            volumenAnualObrasAnoCurso: ''
          },
          seguroObra: {
            sitioTrabajos: '',
            colindantes: '',
            sistemasEvitarDanos: '',
            experienciaParaObraRealizar: '',
            duracionObra: '',
            valorEstimado: '',
            paraQuienRealiza: '',
            tipoMaquinariaEmplear: '',
            caracterIntervieneObra: {
              cuentaPropia: false,
              contratistaPrincipal: false,
              subcontratista: false,
              participanteConsorcioConstruccion: false,
              otros: ''
            }
          }
          
        }
  } 

  function asignarSumaAsegurada (suma) {
    const existe = catalogoSumaAsegurada.find(element => element.label == suma)
    setsumaAseguradaSolicitaAlt(existe != null ? suma : 'Otra cantidad')
  }

  function datosAsesoriaExtra() {
    return {
      reparacionesAfectenStructurales: false,
      apuntalamientos: false,
      demoliciones: false,
      obrasEmpleosExplosivos: false,
      pilotajes: false,
      cimentacion: false,
      excavacion: false,
      techados: false,
      otrosDescribalos: '',
      obrasDistintas: '',
      responsabilidadRiesgoSubcontratista: false,
      participaConsorcioConstruccion: '',
      volumenAnualObrasAnoAnterior: '',
      volumenAnualObrasAnoCurso: ''
    }
  } 

  function initialValues() {
    if (props.accion === 1) {
      return datosAsesoria()
    } else {
      return props.data
    }
  }

  function validationSchema() {
    return yup.object({})
    // return yup.object({
    //   datosGenerales: yup.object().shape({
    //     email: yup
    //       .''()
    //       .email("Correo invalido")
    //   }),
    //   datosRepresentanteLegal: yup.object().shape({
    //     email: yup
    //       .''()
    //       .email("Correo invalido")
    //   }),
    //   contratacionTercero: yup.object().shape({
    //     email: yup
    //       .''()
    //       .email("Correo invalido")
    //   })
    // })
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "empresarial",
        nombre: "Responsabilidad Civil Construcción",
        slug: "responsabilidad-civil-construccion"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  function addAsesoria(index, valor) {    
    formik.setFieldValue(`seguroAnual['subcontratistasEmpleados'][${index}].asesoria`, valor ? datosAsesoriaExtra() : null)
  }
  
  const subContratistaObj = {
    nombre : '',
    tipoTrabajo : '',
    criteriosSeleccion : '',
    asesoria : null
  }

  function addSubContratista() {
    let subContratisas = formik.values.seguroAnual.subcontratistasEmpleados
    subContratisas = [...subContratisas, subContratistaObj]
    formik.setFieldValue('seguroAnual[subcontratistasEmpleados]', subContratisas)
  }

  function deleteItem (_item) {
    formik.setFieldValue('seguroAnual[subcontratistasEmpleados]', formik.values.seguroAnual.subcontratistasEmpleados.filter((item) => item !== _item))
  }

  useEffect(() => {
    if (formik.values.datosGenerales.sumaAseguradaSolicita != '') {
      asignarSumaAsegurada(formik.values.datosGenerales.sumaAseguradaSolicita)
    }
  }, [])

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Responsabilidad Civil Construcción</h1>
      {/* Sección del solicitante */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12  fw-bolder mb-2">Datos generales</h3>
        {/* solicitante */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Solicitante o proponente
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.solicitante}
            invalid={formik.errors.datosGenerales?.solicitante && true}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['solicitante']", e.target.value)
            }}
          />
          {formik.errors.datosGenerales?.solicitante && (
            <FormFeedback>{formik.errors.datosGenerales?.solicitante}</FormFeedback>
          )}
        </div>
        {/* actividadGiro */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Actividad o giro
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.actividadGiro}
            invalid={formik.errors.datosGenerales?.actividadGiro && true}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['actividadGiro']", e.target.value)
            }}
          />
          {formik.errors.datosGenerales?.actividadGiro && (
            <FormFeedback>{formik.errors.datosGenerales?.actividadGiro}</FormFeedback>
          )}
        </div>
        {/* domicilioCodigoPostal */}
        <div className="col-12  col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Domicilio con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.domicilioCodigoPostal}
            invalid={formik.errors.datosGenerales?.domicilioCodigoPostal && true}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['domicilioCodigoPostal']", e.target.value)
            }}
          />
          {formik.errors.datosGenerales?.domicilioCodigoPostal && (
            <FormFeedback>{formik.errors.datosGenerales?.domicilioCodigoPostal}</FormFeedback>
          )}
        </div>
        {/* Domicilio de cobro con CP */}
        <div className="col-12  col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Domicilio de cobro con CP
          </Label>
          <Input
            placeholder=""
            value={formik.values.datosGenerales.domicilioCobroCodigoPostal}
            invalid={formik.errors.datosGenerales?.domicilioCobroCodigoPostal && true}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['domicilioCobroCodigoPostal']", e.target.value)
            }}
          />
          {formik.errors.datosGenerales?.domicilioCobroCodigoPostal && (
            <FormFeedback>{formik.errors.datosGenerales?.domicilioCobroCodigoPostal}</FormFeedback>
          )}
        </div>
        {/* Forma de pago */}
        <div className="col-12 col-md-6 w-input">
          <Label className="form-label fw-bolder" >
            Seleccionar suma asegurada:
          </Label>
          <Select
            id="formaPago"
            className="react-select w-100"
            classNamePrefix="select"
            value={{
              label: sumaAseguradaSolicitaAlt,
              value: sumaAseguradaSolicitaAlt
            }}
            onChange={(e) => {
              setsumaAseguradaSolicitaAlt(e.value)
              formik.setFieldValue("datosGenerales['sumaAseguradaSolicita']",  e.value === 'Otra cantidad' ? '' : e.value)
            }}
            options={catalogoSumaAsegurada}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.sumaAseguradaSolicita && (
            <FormFeedback>{formik.errors.sumaAseguradaSolicita}</FormFeedback>
          )}
        </div>
        {/* Suma asegurada */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Suma asegurada
          </Label>
          <Input
            placeholder=""
            disabled={sumaAseguradaSolicitaAlt != 'Otra cantidad'}
            value={formik.values.datosGenerales.sumaAseguradaSolicita}
            invalid={formik.errors.datosGenerales?.sumaAseguradaSolicita && true}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['sumaAseguradaSolicita']", e.target.value)
            }}
          />
          {formik.errors.datosGenerales?.sumaAseguradaSolicita && (
            <FormFeedback>{formik.errors.datosGenerales?.sumaAseguradaSolicita}</FormFeedback>
          )}
        </div>
        {/* Vigencia */}
        <div className="col-12 d-flex flex-wrap  mb-1 w-input">
          <Label className="col-12 form-label fw-bolder" >
            Vigencia de solicitud
          </Label>
          {/* Inicio */}
          <div className="col-12  col-md-6 mb-1 w-input">
            <Label className="form-label fw-bolder" >
              Inicio
            </Label>
            <Flatpickr
              id='vigenciaSolicitudDesde'
              name='vigenciaSolicitudDesde'
              value={formik.values.datosGenerales?.vigenciaSolicitud.desde}
              className='form-control'
              options={{ dateFormat: 'Y-m-d' }}
              onChange={date => {
                formik.setFieldValue("datosGenerales['vigenciaSolicitud']['desde']", date)
              }
              }
            />
          </div>
          {/* Fin */}
          <div className="col-12  col-md-6 mb-1 w-input">
            <Label className="form-label fw-bolder" >
              Termino
            </Label>
            <Flatpickr
              id='vigenciaSolicitudHasta'
              name='vigenciaSolicitudHasta'
              value={formik.values.datosGenerales?.vigenciaSolicitud.hasta}
              className='form-control'
              options={{ dateFormat: 'Y-m-d' }}
              onChange={date => {
                formik.setFieldValue("datosGenerales['vigenciaSolicitud']['hasta']", date)
              }
              }
            />
          </div>
        </div>
      </div>
      {/* Sección del Seguro Anual */}
      <div className="col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12  fw-bolder">Seguro Anual</h3>
        <h5 className="col-12 mb-2">Indique los ramos de construcción que ha trabajado durante los últimos tres años:</h5>
        {/* tipoServicios array */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Reparaciones que afecten elementos estructurales :
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`reparacionesAfectenStructurales` } 
                id={`reparacionesAfectenStructurales` }
                checked={formik.values.seguroAnual?.reparacionesAfectenStructurales}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['reparacionesAfectenStructurales']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`reparacionesAfectenStructurales` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* tipoServicios array */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
             Apuntalamientos:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`apuntalamientos` } 
                id={`apuntalamientos` }
                checked={formik.values.seguroAnual?.apuntalamientos}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['apuntalamientos']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`apuntalamientos` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* tipoServicios array */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Demoliciones :
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`demoliciones` } 
                id={`demoliciones` }
                checked={formik.values.seguroAnual?.demoliciones}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['demoliciones']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`demoliciones` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* tipoServicios array */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Obras con empleos de explosivos :
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`obrasEmpleosExplosivos` } 
                id={`obrasEmpleosExplosivos` }
                checked={formik.values.seguroAnual?.obrasEmpleosExplosivos}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['obrasEmpleosExplosivos']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`obrasEmpleosExplosivos` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* Pilotajes */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Pilotajes:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`pilotajes` } 
                id={`pilotajes` }
                checked={formik.values.seguroAnual?.pilotajes}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['pilotajes']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`pilotajes` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* Cimentación */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
            Cimentación :
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`cimentacion` } 
                id={`cimentacion` }
                checked={formik.values.seguroAnual?.cimentacion}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['cimentacion']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`cimentacion` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* Excavación */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Excavación:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`excavacion` } 
                id={`excavacion` }
                checked={formik.values.seguroAnual?.excavacion}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['excavacion']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`excavacion` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* Techados */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Techados :
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name={`techados` } 
                id={`techados` }
                checked={formik.values.seguroAnual?.techados}
                onChange={(e) => {
                  formik.setFieldValue("seguroAnual['techados']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for={`techados` }>
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* Otros */}
        <div className="col-12 col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Otros (Descríbalos) 
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroAnual.otrosDescribalos}
            invalid={formik.errors.seguroAnual?.otrosDescribalos && true}
            onChange={(e) => {
              formik.setFieldValue("seguroAnual['otrosDescribalos']", e.target.value)
            }}
          />
          {formik.errors.seguroAnual?.otrosDescribalos && (
            <FormFeedback>{formik.errors.seguroAnual?.otrosDescribalos}</FormFeedback>
          )}
        </div>
        {/* Otros */}
        <div className="col-12 col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Indique si estima que en el futuro realice Obras distintas a las que ha efectuado. Señale cuáles 
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroAnual.obrasDistintas}
            invalid={formik.errors.seguroAnual?.obrasDistintas && true}
            onChange={(e) => {
              formik.setFieldValue("seguroAnual['obrasDistintas']", e.target.value)
            }}
          />
          {formik.errors.seguroAnual?.obrasDistintas && (
            <FormFeedback>{formik.errors.seguroAnual?.obrasDistintas}</FormFeedback>
          )}
        </div>
        {/* participa en Consorcio */}
        <div className="col-12 col-lg-6 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Indique si participa en Consorcio de Construcción
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroAnual.participaConsorcioConstruccion}
            invalid={formik.errors.seguroAnual?.participaConsorcioConstruccion && true}
            onChange={(e) => {
              formik.setFieldValue("seguroAnual['participaConsorcioConstruccion']", e.target.value)
            }}
          />
          {formik.errors.seguroAnual?.participaConsorcioConstruccion && (
            <FormFeedback>{formik.errors.seguroAnual?.participaConsorcioConstruccion}</FormFeedback>
          )}
        </div>
        {/* Valor de los contratos */}
        <div className="col-12 col-lg-6 mb-1 w-input d-flex flex-wrap">
          <Label className="form-label fw-bolder" >
          Indique volumen anual de Obras (Valor de los contratos) durante año anterior y estimación para el año en curso
          </Label>
          <div className="col-6 w-input">
          <Label className="form-label fw-bolder" >
            Durante año anterior
          </Label>
            <Input
              placeholder=""
              value={formik.values.seguroAnual.volumenAnualObrasAnoAnterior}
              invalid={formik.errors.seguroAnual?.volumenAnualObrasAnoAnterior && true}
              onChange={(e) => {
                formik.setFieldValue("seguroAnual['volumenAnualObrasAnoAnterior']", e.target.value)
              }}
            />
            {formik.errors.seguroAnual?.volumenAnualObrasAnoAnterior && (
              <FormFeedback>{formik.errors.seguroAnual?.volumenAnualObrasAnoAnterior}</FormFeedback>
            )}
          </div>
          <div className="col-6 w-input">
            <Label className="form-label fw-bolder" >
              Estimación para el año en curso
            </Label>
            <Input
              placeholder=""
              value={formik.values.seguroAnual.volumenAnualObrasAnoCurso}
              invalid={formik.errors.seguroAnual?.volumenAnualObrasAnoCurso && true}
              onChange={(e) => {
                formik.setFieldValue("seguroAnual['volumenAnualObrasAnoCurso']", e.target.value)
              }}
            />
            {formik.errors.seguroAnual?.volumenAnualObrasAnoCurso && (
              <FormFeedback>{formik.errors.seguroAnual?.volumenAnualObrasAnoCurso}</FormFeedback>
            )}
          </div>
        </div>
        {/* Subcontratistas */}
        <div className="col-12 mb-1 w-input ">
          <Label className="form-label fw-bolder" >
            Indique si estima que en el futuro realice Obras distintas a las que ha efectuado. Señale cuáles
          </Label>
          <div className="ww-auto mx-auto mb-1">
              <Button
                className=""
                color="success"
                size="sm"
                onClick={ () => { addSubContratista() } }
              >Agregar subcontratista </Button>
          </div>
          {formik.values.seguroAnual.subcontratistasEmpleados.length > 0 &&
            formik.values.seguroAnual.subcontratistasEmpleados.map((_item, index) => (
              <div className="col-12 w-input d-flex flex-wrap mb-2">
                <div className="col-12 d-flex align-middle ">
                  <Label className=" ww-50A form-label my-auto  fw-bolder" for="tipo">
                    Subcontratista # {index + 1}:
                  </Label>
                  <Button color='danger' className='cursor-pointer fw-bolder text-nowrap px-1' size="sm" onClick={ () => { deleteItem(_item) }} outline>
                    <Trash size={14} className='me-50' />
                    <span className="align-middle fw-bolder">Eliminar</span>
                  </Button>
                  {/* <X size={18} className='cursor-pointer' onClick={ () => { deleteItem(_item) }} /> */}
                </div>
                  {/* Otros */}
                  <div className="col-12 col-lg-8 mb-1 w-input">
                    <Label className="form-label fw-bolder" >
                      Nombre: 
                    </Label>
                    <Input
                      placeholder=""
                      value={formik.values.seguroAnual.subcontratistasEmpleados[index].nombre}
                      invalid={formik.errors.seguroAnual?.subcontratistasEmpleados[index].nombre && true}
                      onChange={(e) => {
                        formik.setFieldValue(`seguroAnual['subcontratistasEmpleados'][${index}].nombre`, e.target.value)
                      }}
                    />
                  </div>
                  {/* Otros */}
                  <div className="col-12 col-md 6 col-lg-4 mb-1 w-input">
                    <Label className="form-label fw-bolder" >
                      Tipo de trabajo:
                    </Label>
                    <Input
                      placeholder=""
                      value={formik.values.seguroAnual.subcontratistasEmpleados[index].tipoTrabajo}
                      invalid={formik.errors.seguroAnual?.subcontratistasEmpleados[index].tipoTrabajo && true}
                      onChange={(e) => {
                        formik.setFieldValue(`seguroAnual['subcontratistasEmpleados'][${index}].tipoTrabajo`, e.target.value)
                      }}
                    />
                  </div>
                  {/* Otros */}
                  <div className="col-12 mb-1 w-input">
                    <Label className="form-label fw-bolder" >
                      Criterios de selección:
                    </Label>
                    <Input
                      placeholder=""
                      value={formik.values.seguroAnual.subcontratistasEmpleados[index].criteriosSeleccion}
                      invalid={formik.errors.seguroAnual?.subcontratistasEmpleados[index].criteriosSeleccion && true}
                      onChange={(e) => {
                        formik.setFieldValue(`seguroAnual['subcontratistasEmpleados'][${index}].criteriosSeleccion`, e.target.value)
                      }}
                    />
                  </div>
                  {/* Validacion */}
                  <div className="col-12 w-input d-flex">
                    <div className="ww-auto mmr-1">
                      <Label className='form-label fw-bolder align-middle ' >
                        En caso de que desee que la responsabilidad del riesgo de subcontratista sea incluído en el seguro, proporcione por cada subcontratista la información a que se refiere este cuestionario.:
                      </Label>
                    </div>
                    <div className="ww-50">
                      <div className='form-switch '>
                        <Input 
                          type='switch' 
                          checked={formik.values.seguroAnual.subcontratistasEmpleados[index].asesoria != null}
                          name={`Check-${index}`} 
                          id={`Check-${index}`}
                          onChange={(e) => {
                            addAsesoria(index, e.target.checked)
                          }}
                        />
                        <Label className='form-check-label' for={`Check-${index}`}>
                          <span className='switch-icon-left'>
                            <Check size={14} />
                          </span>
                          <span className='switch-icon-right'>
                            <X size={14} />
                          </span>
                        </Label>
                      </div>
                    </div>
                  </div>
                  {
                    formik.values.seguroAnual.subcontratistasEmpleados[index].asesoria != null && 
                      <ResponsabilidadCivilConstruccionExtraForm
                        data={formik.values.seguroAnual.subcontratistasEmpleados[index].asesoria}
                        form={formik}
                        index={index}
                      />
                  }
                  
              </div>
            ))}
        </div>
      </div>
      {/* Sección del Seguro de obra */}
      <div className=" col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12  fw-bolder">Seguro por Obra</h3>
        <h5 className="col-12  fw-bolder">Describa la Obra por realizar</h5>
        {/* solicitante */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <label for="textarea">Describa el sitio de los trabajos</label>
          <Input
            type="textarea"
            value={formik.values.seguroObra?.sitioTrabajos}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['sitioTrabajos']", e.target.value)
            }}
            rows="3"
          />
          {formik.errors.seguroObra?.sitioTrabajos && (
            <FormFeedback>{formik.errors.seguroObra?.sitioTrabajos}</FormFeedback>
          )}
        </div>
        {/* solicitante */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <label for="textarea">Colindantes</label>
          <Input
            type="textarea"
            value={formik.values.seguroObra?.colindantes}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['colindantes']", e.target.value)
            }}
            rows="3"
          />
          {formik.errors.seguroObra?.colindantes && (
            <FormFeedback>{formik.errors.seguroObra?.colindantes}</FormFeedback>
          )}
        </div>
        {/* solicitante */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <label for="textarea">Sistemas previstos para evitar daños</label>
          <Input
            type="textarea"
            value={formik.values.seguroObra?.sistemasEvitarDanos}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['sistemasEvitarDanos']", e.target.value)
            }}
            rows="3"
          />
          {formik.errors.seguroObra?.sistemasEvitarDanos && (
            <FormFeedback>{formik.errors.seguroObra?.sistemasEvitarDanos}</FormFeedback>
          )}
        </div>
        {/* solicitante */}
        <div className="col-12 col-md-6 mb-1 w-input">
          <label for="textarea">Indique experiencia con la que cuenta para la Obra por realizar</label>
          <Input
            type="textarea"
            value={formik.values.seguroObra?.experienciaParaObraRealizar}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['experienciaParaObraRealizar']", e.target.value)
            }}
            rows="3"
          />
          {formik.errors.seguroObra?.experienciaParaObraRealizar && (
            <FormFeedback>{formik.errors.seguroObra?.experienciaParaObraRealizar}</FormFeedback>
          )}
        </div>
        {/* duracionObra */}
        <div className="col-12 col-md-3 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Indique duración
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroObra.duracionObra}
            invalid={formik.errors.seguroObra?.duracionObra && true}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['duracionObra']", e.target.value)
            }}
          />
          {formik.errors.seguroObra?.duracionObra && (
            <FormFeedback>{formik.errors.seguroObra?.duracionObra}</FormFeedback>
          )}
        </div>
        {/* valorEstimado */}
        <div className="col-12 col-md-3 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Valor estimado de la obra
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroObra.valorEstimado}
            invalid={formik.errors.seguroObra?.valorEstimado && true}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['valorEstimado']", e.target.value)
            }}
          />
          {formik.errors.seguroObra?.valorEstimado && (
            <FormFeedback>{formik.errors.seguroObra?.valorEstimado}</FormFeedback>
          )}
        </div>
        {/* paraQuienRealiza */}
        <div className="col-12 col-md-3 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Indique el caracter con el que interviene en la Obra
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroObra.paraQuienRealiza}
            invalid={formik.errors.seguroObra?.paraQuienRealiza && true}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['paraQuienRealiza']", e.target.value)
            }}
          />
          {formik.errors.seguroObra?.paraQuienRealiza && (
            <FormFeedback>{formik.errors.seguroObra?.paraQuienRealiza}</FormFeedback>
          )}
        </div>
        {/* tipoMaquinariaEmplear */}
        <div className="col-12 col-md-3 mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Indique tipo de maquinaria de construcción a emplear
          </Label>
          <Select
            id="tipoMaquinariaEmplear"
            className="react-select w-100"
            classNamePrefix="select"
            value={{
              label: formik.values.seguroObra.tipoMaquinariaEmplear,
              value: formik.values.seguroObra.tipoMaquinariaEmplear
            }}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['seguroObra']['tipoMaquinariaEmplear']", e.value)
            }}
            options={[catalogoTipoMaquinaria]}
            isClearable={false}
            isSearchable={false}
          />
          {formik.errors.seguroObra?.tipoMaquinariaEmplear && (
            <FormFeedback>{formik.errors.seguroObra?.tipoMaquinariaEmplear}</FormFeedback>
          )}
        </div>
        <h5 className="col-12 mt-2">Indique el caracter con el que interviene en la Obra</h5>
        {/* cuentaPropia */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Por cuenta propia:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name="seguroObra['caracterIntervieneObra']['cuentaPropia']" 
                id="seguroObra['caracterIntervieneObra']['cuentaPropia']"
                checked={formik.values.seguroObra?.caracterIntervieneObra.cuentaPropia}
                onChange={(e) => {
                  formik.setFieldValue("seguroObra['caracterIntervieneObra']['cuentaPropia']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for="seguroObra['caracterIntervieneObra']['cuentaPropia']">
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* subcontratista */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Subcontratista:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name="seguroObra['caracterIntervieneObra']['subcontratista']" 
                id="seguroObra['caracterIntervieneObra']['subcontratista']"
                checked={formik.values.seguroObra?.caracterIntervieneObra.subcontratista}
                onChange={(e) => {
                  formik.setFieldValue("seguroObra['caracterIntervieneObra']['subcontratista']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for="seguroObra['caracterIntervieneObra']['subcontratista']">
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* contratistaPrincipal */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Contratista principal:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name="seguroObra['caracterIntervieneObra']['contratistaPrincipal']" 
                id="seguroObra['caracterIntervieneObra']['contratistaPrincipal']"
                checked={formik.values.seguroObra?.caracterIntervieneObra.contratistaPrincipal}
                onChange={(e) => {
                  formik.setFieldValue("seguroObra['caracterIntervieneObra']['contratistaPrincipal']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for="seguroObra['caracterIntervieneObra']['contratistaPrincipal']">
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* participanteConsorcioConstruccion */}
        <div className="col-12 col-md-6 w-input d-flex ">
          <div className=" ww-50A mmr-1">
            <Label className='form-label fw-bolder align-middle ' >
              Participante en Consorcio de Construcción:
            </Label>
          </div>
          <div className="ww-50">
            <div className='form-switch '>
              <Input 
                type='switch' 
                name="seguroObra['caracterIntervieneObra']['participanteConsorcioConstruccion']" 
                id="seguroObra['caracterIntervieneObra']['participanteConsorcioConstruccion']"
                checked={formik.values.seguroObra?.caracterIntervieneObra.participanteConsorcioConstruccion}
                onChange={(e) => {
                  formik.setFieldValue("seguroObra['caracterIntervieneObra']['participanteConsorcioConstruccion']", e.target.checked)
                }}
              />
              <Label className='form-check-label' for="seguroObra['caracterIntervieneObra']['participanteConsorcioConstruccion']">
                <span className='switch-icon-left'>
                  <Check size={14} />
                </span>
                <span className='switch-icon-right'>
                  <X size={14} />
                </span>
              </Label>
            </div>
          </div>
        </div>
        {/* solicitante */}
        <div className="col-12  mb-1 w-input">
          <Label className="form-label fw-bolder" >
            Otros
          </Label>
          <Input
            placeholder=""
            value={formik.values.seguroObra.caracterIntervieneObra.otros}
            invalid={formik.errors.seguroObra?.caracterIntervieneObra.otros && true}
            onChange={(e) => {
              formik.setFieldValue("seguroObra['caracterIntervieneObra']['otros']", e.target.value)
            }}
          />
          {formik.errors.datosGenerales?.solicitante && (
            <FormFeedback>{formik.errors.datosGenerales?.solicitante}</FormFeedback>
          )}
        </div>
      </div>
      {/* Sección del Seguro anual y de obra */}
      <div className=" col-12 d-flex flex-wrap mt-2">
        <h3 className="col-12  fw-bolder">Seguro Anual y Seguro por Obra</h3>
        {/* solicitante */}
        <div className="col-12 mb-1 w-input">
          <label for="textarea">Indique experiencia en siniestros o reclamaciones durante los tres últimos años (Detalle los daños ocasionados, sus causas y montos)</label>
          <Input
            type="textarea"
            value={formik.values.datosGenerales?.experienciaSiniestrosTresUltimosAnos}
            onChange={(e) => {
              formik.setFieldValue("datosGenerales['experienciaSiniestrosTresUltimosAnos']", e.target.value)
            }}
            rows="3"
          />
          {formik.errors.datosGenerales?.experienciaSiniestrosTresUltimosAnos && (
            <FormFeedback>{formik.errors.datosGenerales?.experienciaSiniestrosTresUltimosAnos}</FormFeedback>
          )}
        </div>
      </div>
      {/* Btn de guardar */}
      <div className=" mb-1 d-flex justify-content-end">
        <Button className="m-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default AsesoriaResponsabilidadCivilConstruccionForm
